import ApplicationPortal from 'state/enums/ApplicationPortal'

export default function getPortal(): ApplicationPortal {
    return ApplicationPortal.OCTANE
}
